import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

interface Passengers {
  age: number
  height: number
  size: number
  type: string
}

export interface RecommendationRequest {
  budget: number
  partExchange: boolean
  finance: boolean
  passengers: Passengers[]
  roadMotorway: number
  roadCity: number
  roadCountry: number
  distanceShort: number
  distanceMedium: number
  distanceLong: number
  drivingFrequency: number
  importanceAbstract: string[]
  importanceTextual: string[]
}

const baseURL = getEnv(Env.RecommendationServiceUrl)

const service = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getRecommendations = (body: Partial<RecommendationRequest>) => {
  return service.request<Cinch.RecommendationsResponse>({
    url: '/recommendations',
    method: 'POST',
    data: body,
  })
}
